import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { isAuthorized } from "src/config/store/slices/auth/auth.slice";
import { ROUTE_PATHS } from "src/config";

type Props = {
  children: JSX.Element;
};

export const ProtectedRoute = ({ children }: Props) => {
  const token = useSelector(isAuthorized);

  return token ? (
    children
  ) : (
    <Navigate to={`/auth/${ROUTE_PATHS.LOGIN}`} replace />
  );
};

export default ProtectedRoute;
